import { createGlobalStyle } from 'styled-components';

// No @font-face here: re-injecting this style in dev recreates the font faces (see ./fonts.css).
export default createGlobalStyle`
    h1,h2,h3,h4,h5 {
        font-family: "ProximaNova", Arial, sans-serif;
        font-weight: 600;
    }

    html body {
        font-family: "ProximaNova", Arial, sans-serif;
        p, span {
            font-family: "ProximaNova", Arial, sans-serif;
        }
    }


    strong, b {
        font-weight: 600;
    }

    h1 strong, h1 b,
    h2 strong, h2 b,
    h3 strong, h3 b,
    h4 strong, h4 b,
    h5 strong, h5 b {
        font-weight: 700;
    }
`;
